import { COUNTRY_ISO3_CODES, NANP_ISO2_LIST } from "constants/index";
import dayjs from "dayjs";
import apiService from "modules/api/apiService";
import { LOG_MESSAGE } from "modules/api/endpoint";
import phone from "phone";

export const redirect = (url: string) => {
  try {
    window.history.pushState(null, "", url);
  } catch (e) {
    document.location.href = url;
  }
};

export const formatTitle = (title: string) => {
  return `${title} | Activelinxx`;
};

export const isLoginLocation = () => {
  return /^\/login.{0,}$/.test(document.location.pathname);
};

export const formatName = (firstName: string, lastName: string) => {
  return `${firstName} ${lastName}`.replace(/\s+/g, " ").trim();
};

export const stringToColor = (str: string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const stringAvatar = (name: string) => {
  return {
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    sx: {
      bgcolor: stringToColor(name),
    },
  };
};
export const arraySearch = (array: any[], keyword: string): any[] => {
  const searchTerm = keyword.toLowerCase();

  return array.filter((value) => {
    return (
      value.firstName.toLowerCase().match(new RegExp(searchTerm, "g")) ||
      value.lastName.toLowerCase().match(new RegExp(searchTerm, "g")) ||
      value.status.toLowerCase().match(new RegExp(searchTerm, "g")) ||
      value.id.toLowerCase().match(new RegExp(searchTerm, "g"))
    );
  });
};

export const formatDate = (givenDate: string, givenDateFormat: string, format: string) => {
  return dayjs(givenDate, givenDateFormat).format(format);
};

/**
 * Calculate the time from decimal to time string format HH:mm:ss
 *
 * @param time
 * @param secondDiff - The number multiple to become second, default is 3600
 */
export const formatTimeDuration = (time: number, secondDiff: number = 3600) => {
  const totalSeconds = time * secondDiff;
  const totalHours = Math.floor(totalSeconds / 3600);
  const totalMinutes = Math.floor(totalSeconds / 60);

  const minutes = Math.floor(totalMinutes - Math.floor(totalHours * 60));
  const seconds = Math.floor(totalSeconds - (totalHours * 3600 + minutes * 60));

  const timeStr = `${totalHours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

  return timeStr;
};

export const isDate = (date) => {
  return !isNaN(new Date(date).getDate());
};

export const scrollToTop = (htmlElementQuery?) => {
  //scrolling the screen up moving from one screen to another.
  if (!htmlElementQuery) {
    setTimeout(() => {
      window.scrollTo({ behavior: "smooth", top: 0 });
    }, 0);
  } else {
    document.querySelector(htmlElementQuery).scrollTo({ behavior: "smooth", top: 0 });
  }
};

export const normalize = (phoneNumber) => {
  if (!phoneNumber) return phoneNumber;
  // let num = phoneNumber.replace(
  //   /^[\+\d{1,3}\-\s]*\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
  //   "$1$2$3"
  // );
  let num = phoneNumber.replaceAll("(", "");
  num = num.replaceAll(")", "");
  num = num.replaceAll(" ", "");
  num = num.replaceAll("-", "");
  num = num.replaceAll("+", "");
  if (num.length && num[0] == 1) num = num.replace("1", "");
  return num;
};

export const formatPhoneNumber = (phoneNumber, formatString, options = null) => {
  // Normalize the phone number first unless not asked to do so in the options
  if (!options || !options.normalize) {
    phoneNumber = normalize(phoneNumber);
  }
  if (!phoneNumber || phoneNumber === "") return "";

  for (var i = 0, l = phoneNumber.length; i < l; i++) {
    formatString = formatString.replace("N", phoneNumber[i]);
  }
  const arr = formatString.split(/N(.*)/s);

  const finalStr = arr.length ? arr[0] : formatString;
  if (finalStr.length && finalStr[finalStr.length - 1] === "-") {
    // finalStr[finalStr.length - 1] = "";
    return finalStr.replace(/.$/, "");
  }
  return finalStr;
};

export const validatePhoneNumber = (number = "", country = "") => {
  if (number && NANP_ISO2_LIST.includes(COUNTRY_ISO3_CODES[country]?.iso2)) {
    const countryCode = COUNTRY_ISO3_CODES[country]?.iso3;
    return phone(number, { country: `${countryCode}` }).isValid;
  } else {
    return true;
  }
};

export const parsePhoneNumber = (text) => {
  if (!text) return "";
  let t = text.replaceAll("-", "");
  t = t.replaceAll(" ", "");
  t = t.replaceAll("(", "");
  t = t.replaceAll(")", "");
  return t;
};

export const onlyAllowNumber = (evt) => {
  if (evt.key === "Backspace" || evt.code === "Backspace") return true;
  if (evt.key.includes("Arrow") || evt.code.includes("Arrow")) return true;
  if (evt.ctrlKey || evt.metaKey) return true;

  if (!Number.isInteger(parseInt(evt.key))) {
    evt.preventDefault();
  } else {
    return true;
  }
};

export const bufferFitlinxxId = (id: string) => {
  const padString = "0";
  id = "" + id;
  while (id.length < 5) {
    id = padString + id;
  }
  return id;
};

export const logMessage = async (params) => {
  console.log("Got the log message: ", params);
  try {
    let result = await apiService.put(LOG_MESSAGE, params);
    return result;
  } catch (error) {
    throw error.response.data.message;
  }
};

export const logMessageAlt = async (
  params
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    console.log("Got the log message: ", params);
    let result = await apiService.put(LOG_MESSAGE, params);
    console.log("Result(logMessage):\n", result);
    return {
      data: result.data.payload,
      success: true,
    };
  } catch (error) {
    console.log(`Result(logMessage):\n`, error.response.data.message);
    throw error.response.data.message;
  }
};

export const convertToLocalTimeZone = (date) => {
  const origDate = new Date(date);
  const utc = new Date();
  const offSet = utc.getTimezoneOffset();
  const adjDate = new Date(origDate.getTime() - offSet * 60000);

  return adjDate;
};

export const convertSecondsToHoursAndMinutes = (totalSeconds) => {
  const totalMinutes = Math.floor(totalSeconds / 60);

  const seconds = totalSeconds % 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours}:${minutes}:${seconds}`;
};
export const isOver100YearsOld = (dateString: string) => {
  const givenDate = new Date(dateString);

  const currentDate = new Date();

  const differenceInYears = currentDate.getFullYear() - givenDate.getFullYear();

  if (differenceInYears > 100) {
    return true;
  } else if (differenceInYears === 100) {
    if (currentDate.getMonth() > givenDate.getMonth()) {
      return true;
    } else if (
      currentDate.getMonth() === givenDate.getMonth() &&
      currentDate.getDate() >= givenDate.getDate()
    ) {
      return true;
    }
  }

  return false;
};
